import React from 'react'

import './CostSharingPercentageSummary.less'

interface CostPercentageSummaryProps {
  percentage: number
  hasDeductible: boolean
  translate: (key: string) => string
}

const CostSharingPercentageSummary: React.FC<CostPercentageSummaryProps> = ({
  percentage,
  hasDeductible,
  translate,
}) => {
  const getCostSharingPercentageDescription = () => {
    if (hasDeductible) {
      return translate('summary.cost-sharing-percentage-description-for-deductible')
    } else {
      return translate('summary.cost-sharing-percentage-default-description')
    }
  }

  return (
    <div className="cost_sharing_percentage_summary">
      <h6 className="summary_title">{translate('summary.cost-sharing-percentage-title')}</h6>
      <h3 className="percentage_value">{percentage}%</h3>
      <h6 className="percentage_description pt-16">{getCostSharingPercentageDescription()}</h6>
    </div>
  )
}

export default CostSharingPercentageSummary
